import React, { useEffect, useState } from "react";
import { Button, Form, Input, message, Spin } from "antd";
import { connect } from "react-redux";
import { history } from "../appRedux/store";
import { get } from "lodash";
import { getAuthenticatorDetailsAPI, setIsAuthAPI } from "../services/users-service";
import { updateisAuthenticatorStatus, updateOtpVerificationStatus } from "../appRedux/actions";

function AuthenticatorQR(props) {
    const { authUser } = props;

    const [data, setData] = useState({
        qr: "",
        loading: true,
    });

    async function handleClick() {
        try {
            setData(prev => ({ ...prev, loading: true }));

            const response = await setIsAuthAPI(authUser.email);
            if (!response.success)
                throw new Error("Counld not update, please try again");

            message.success("User Account Created successfully");
            props.updateisAuthenticatorStatus();
            history.push('/verify-auth-otp');
        } catch (error) {
            message.error(error.message || "Something went wrong, please try again");
        } finally {
            setData(prev => ({ ...prev, loading: false }));
        }
    }

    useEffect(() => {
        let isMounted = true;

        async function getAuthenticatorDetails() {
            try {
                const response = await getAuthenticatorDetailsAPI({
                    email: authUser.email,
                });

                if (isMounted && response.success) {
                    setData((prev) => ({ loading: false, qr: response.data }));
                } else if (isMounted) {
                    throw new Error("Error getting the QR code, please try again");
                }
            } catch (error) {
                if (isMounted) {
                    message.error(
                        error.message || "Something went wrong, please try again"
                    );
                }
            } finally {
                if (isMounted) {
                    setData((prev) => ({ ...prev, loading: false }));
                }
            }
        }
        // getAuthenticatorDetails();

        if (!authUser) {
            history.push('/signin');
        } else {
            getAuthenticatorDetails()
        }
    }, [authUser]);

    return (
        <div className="gx-app-login-wrap">
            <div className="verify-container">
                <div>
                    <p className="authenticator-heading">
                        Secure your Account with 2-Step Verification
                    </p>
                </div>
                <div className="verify-container-block">
                    <Spin spinning={data.loading}>
                        <img className="authenticator-qr" alt="Authentication Qr" src={data.qr} />
                    </Spin>

                    <p style={{ textAlign: "center", fontWeight: 400 }}>
                        Scan the QR code below using your google authenticator app. This
                        will generate a time-based verification code to enhance your account
                        security. Then click "Next"
                    </p>
                </div>
                <Button
                    block type="primary"
                    onClick={handleClick}
                    loading={data.loading}
                >
                    {"Next"}
                </Button>
            </div>
        </div>
    )
}

const mapStateToProps = ({ auth }) => {
    const { authUser } = auth;
    return { authUser }
};

export const mapDispatchToProps = dispatch => ({
    updateisAuthenticatorStatus: (isAuthenticator) => dispatch(updateisAuthenticatorStatus(isAuthenticator))
});


export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatorQR);